import styled from 'styled-components';

import { TextInput } from 'components/uikit/Form/TextInput/TextInput';
import { Button } from 'components/uikit/Button/Button';

export const Container = styled.div`
  display: flex;
  align-items: center;
  flex-direction: column;
  width: 360px;
  min-height: 360px;
  background-color: var(--color-white);
  padding: 32px;
  border-radius: 32px;
  gap: 24px;
`;

export const Wrapper = styled.div`
  display: flex;
  align-items: center;
  flex-direction: column;
  width: 100%;
  gap: ${(p) => (p.loginFirstRender ? '12px' : '8px')};
`;

export const EmailInput = styled(TextInput).attrs({ size: 'l', theme: '2' })`
  width: 100%;
`;

export const PasswordInput = styled(EmailInput)``;

export const NextButton = styled(Button).attrs({ size: 'l' })`
  width: 100%;
`;

export const LoginButton = styled(NextButton)``;

export const TextWrapper = styled.div`
  display: flex;
  align-items: center;
  flex-direction: column;
  width: 100%;
  gap: ${(p) => (p.loginFirstRender ? '0px' : '16px')};
`;

export const Description = styled.span`
  text-align: center;
  width: 100%;
  margin: 0px;
  color: var(--color-grey-11_60);

  font: var(--font-regular-15);
`;

export const Approval = styled(Description)`
  font: var(--font-regular-11);
`;

export const PhoneNumber = styled.span`
  color: var(--color-grey-11_60);

  font: var(--font-large-11);
`;
